import React from 'react';
import { Plus } from 'lucide-react';

const CreateLinkForm = ({ newLinkData, setNewLinkData, onCreate, generating = false }) => {
    return (
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100">
            <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
                <Plus size={20} className="text-indigo-600" />
                Создать новую ссылку
            </h3>
            <p className="text-sm text-slate-500 mb-4">
                Ссылка ведёт на Telegram-бота: <code className="bg-slate-100 px-1 rounded">https://t.me/Starspay9bot?start=KEYWORD</code>.
                При переходе пользователь открывает бота и система отслеживает переходы и выручку по этой ссылке.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
                <div>
                    <label className="block text-xs font-semibold text-slate-500 uppercase mb-1">
                        Ключевое слово
                    </label>
                    <input
                        type="text"
                        placeholder="Например: test или starsbybot"
                        className="w-full px-4 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        value={newLinkData.keyword || ''}
                        onChange={(e) => setNewLinkData({ ...newLinkData, keyword: e.target.value })}
                    />
                    <p className="text-xs text-slate-500 mt-1">
                        Ссылка будет: <code className="bg-slate-100 px-1 rounded">https://t.me/Starspay9bot?start={newLinkData.keyword || 'KEYWORD'}</code>
                    </p>
                </div>
                <button
                    onClick={onCreate}
                    disabled={generating}
                    className="bg-indigo-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-indigo-700 transition h-[42px] disabled:opacity-50"
                >
                    {generating ? '…' : 'Создать'}
                </button>
            </div>
        </div>
    );
};

export default CreateLinkForm;